import React from 'react';

import StructuredTableFormOutsideNotebook from './StructuredTableFormOutsideNotebook';
import StructuredTableOutsideNotebook, {
  StructuredTableOutsideNotebookProps,
} from './StructuredTableOutsideNotebook';

export const TableOrFormRenderOptions = {
  TABLE: 'TABLE',
  FORM: 'FORM',
} as const;

/** The limit on the number of rows allowed in Form view. Otherwise must use Table View */
export const FORM_ROW_LIMIT = 50;

export type TableOrFormRenderOptionsType = keyof typeof TableOrFormRenderOptions;

export interface StructuredTableOrFormOutsideNotebookProps extends StructuredTableOutsideNotebookProps {
  shouldShowAs?: TableOrFormRenderOptionsType;
}

export default function StructuredTableOrFormOutsideNotebook(
  props: StructuredTableOrFormOutsideNotebookProps
): JSX.Element {
  if (props.shouldShowAs === TableOrFormRenderOptions.FORM) {
    return <StructuredTableFormOutsideNotebook {...props} />;
  }
  return (
    <div>
      <StructuredTableOutsideNotebook {...props} />
    </div>
  );
}
